import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { baseApi, apiMiddleware } from "./api";
import productReducer from "../features/product/productSlice";
import languageReducer from "../features/header/language/languageSlice";
import headerUiReducer from "../features/header/headerUiSlice";
import checkoutReducer from "../features/checkout/checkoutSlice";

// Configure store with reducers and middleware
export const store = configureStore({
  reducer: {
    // Add the API reducer as a specific slice
    [baseApi.reducerPath]: baseApi.reducer,
    // Add other reducers
    product: productReducer,
    language: languageReducer,
    headerUi: headerUiReducer,
    checkout: checkoutReducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other RTK Query features
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiMiddleware), // baseApi middleware is already included here
});

// Set up listeners for RTK Query
setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
